import { render, staticRenderFns } from "./comp_CreditCardTransactionDetail.vue?vue&type=template&id=247f3c98&scoped=true&"
import script from "./comp_CreditCardTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./comp_CreditCardTransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./comp_CreditCardTransactionDetail.vue?vue&type=style&index=0&id=247f3c98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f3c98",
  null
  
)

export default component.exports